import { render } from "./ReferenceDetail.vue?vue&type=template&id=726eccde&scoped=true&ts=true"
import script from "./ReferenceDetail.vue?vue&type=script&lang=ts"
export * from "./ReferenceDetail.vue?vue&type=script&lang=ts"

import "./ReferenceDetail.vue?vue&type=style&index=0&id=726eccde&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726eccde"]])

export default __exports__